module.controller('fraudCtrl', ['$scope', '$http','baseURI', 'Transform', '$stateParams', '$window', 'Session', function($scope, $http,baseURI, Transform, $stateParams, $window, Session){

  var vm = this;


    vm.title = 'Suspended Account';
    vm.info = 'Your ' + $scope.brand.commonProgramName +' account has been suspended due to unusual activity associated with your account or related accounts.';
    vm.helperText = 'In order to lift this restriction';
   
}]);


